import axisBUrl from '../../../assets/fonts/AxisRound50StdN-B.otf?url';
import axisLUrl from '../../../assets/fonts/AxisRound50StdN-L.otf?url';
import axisMUrl from '../../../assets/fonts/AxisRound50StdN-M.otf?url';
import axisRUrl from '../../../assets/fonts/AxisRound50StdN-R.otf?url';

/**
 * MA テロップ焼き込みで使えるフォントの定義テーブル。
 *
 * UI と同じ AXIS ROUND 50（`soremo_style.scss` の `@font-face` が自己ホスト配信している
 * `src/assets/fonts/AxisRound50StdN-*.otf`）をそのまま ffmpeg.wasm の仮想 FS に載せて
 * `subtitles=...:fontsdir=` で参照する。`?url` import により `@font-face` と同じ
 * ハッシュ付きアセットを指すため、UI 表示でキャッシュ済みなら追加ダウンロードは発生しない。
 *
 * - assFontName: ASS の `Fontname` / `\fn` に書く名前。libass は fontconfig なしでも
 *   OTF 内部の family / fullname で照合するため、CSS の別名（"A+mfCv-AXISラウンド 50 L StdN"）
 *   ではなく内部名（fullname）を使う
 * - cssFamily: 設定画面の見本表示（CSS）で使うファミリー名（`soremo_style.scss` と同じ）
 *
 * 別フォント（M PLUS 等）を追加する場合はこのテーブルに 1 件足すだけでよい。
 */
export interface MaTelopFont {
  key: string;
  /** 設定画面の表示名 */
  label: string;
  /** ASS に書くフォント名（OTF 内部の fullname） */
  assFontName: string;
  /** 見本表示用の CSS font-family */
  cssFamily: string;
  /** アセット URL（Vite の ?url import） */
  url: string;
  /** 仮想 FS 上のファイル名 */
  fileName: string;
}

export const MA_TELOP_FONTS: readonly MaTelopFont[] = [
  {
    key: 'axis-round-l',
    label: 'AXIS ROUND 50 L',
    assFontName: 'AXIS Round 50 StdN L',
    cssFamily: '"A+mfCv-AXISラウンド 50 L StdN"',
    url: axisLUrl,
    fileName: 'AxisRound50StdN-L.otf',
  },
  {
    key: 'axis-round-r',
    label: 'AXIS ROUND 50 R',
    assFontName: 'AXIS Round 50 StdN R',
    cssFamily: '"A+mfCv-AXISラウンド 50 R StdN"',
    url: axisRUrl,
    fileName: 'AxisRound50StdN-R.otf',
  },
  {
    key: 'axis-round-m',
    label: 'AXIS ROUND 50 M',
    assFontName: 'AXIS Round 50 StdN M',
    cssFamily: '"A+mfCv-AXISラウンド 50 M StdN"',
    url: axisMUrl,
    fileName: 'AxisRound50StdN-M.otf',
  },
  {
    key: 'axis-round-b',
    label: 'AXIS ROUND 50 B',
    assFontName: 'AXIS Round 50 StdN B',
    cssFamily: '"A+mfCv-AXISラウンド 50 B StdN"',
    url: axisBUrl,
    fileName: 'AxisRound50StdN-B.otf',
  },
];

/** 既定フォント（UI の見出し等と同じ AXIS ROUND 50 M） */
export const DEFAULT_MA_TELOP_FONT_KEY = 'axis-round-m';

/** キーからフォント定義を解決（未知キーは既定 = AXIS ROUND 50 M） */
export function resolveMaTelopFont(key: string | null | undefined): MaTelopFont {
  return (
    MA_TELOP_FONTS.find(font => font.key === key) ??
    (MA_TELOP_FONTS.find(font => font.key === DEFAULT_MA_TELOP_FONT_KEY) as MaTelopFont)
  );
}
